/* Medivital – saját visszaszámláló (az Essential Countdown Timer helyett).
   Beállítások: Shopify admin → Tartalom → Metaobjektumok → Visszaszámláló.
   Minden időpont magyar idő (Europe/Budapest), a látogató órájától függetlenül. */
(function () {
  if (window.__mvcd) { window.__mvcd.scan(); return; }

  var TZ = 'Europe/Budapest';
  var DAYS = { 'Vasárnap': 0, 'Hétfő': 1, 'Kedd': 2, 'Szerda': 3, 'Csütörtök': 4, 'Péntek': 5, 'Szombat': 6 };
  var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });

  function store(kind) { try { var s = window[kind]; s.setItem('__t', '1'); s.removeItem('__t'); return s; } catch (e) { return null; } }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { s && s.setItem(k, v); } catch (e) {} }

  /* --- Budapesti idő ---------------------------------------------------- */
  function parts(ms) {
    var o = {};
    fmt.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = +p.value; });
    return o;
  }
  function offset(ms) {
    var p = parts(ms);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
  }
  /* budapesti falióra-idő → UTC ms */
  function bp(y, m, d, h, mi) {
    var guess = Date.UTC(y, m - 1, d, h, mi);
    var r = guess - offset(guess);
    var o2 = offset(r);
    return guess - o2;
  }
  function hm(s) { var a = String(s || '00:00').split(':'); return (+a[0] || 0) * 60 + (+a[1] || 0); }

  /* --- Mikor jár le most? (null = most nem fut) ------------------------- */
  function endsAt(c, now) {
    if (c.start && now < c.start * 1000) return null;

    if (c.type === 'Fix perc látogatónként') {
      if (!(c.mins > 0)) return null;
      if (c.end && now >= c.end * 1000) return null;
      var key = 'mvcd_fm_' + c.h, st = +get(LS, key);
      if (!st || st > now) { st = now; set(LS, key, st); }
      var e = st + c.mins * 60000;
      if (now >= e) {
        if (!c.restart) return null;
        set(LS, key, now); e = now + c.mins * 60000;
      }
      return e;
    }

    if (c.type === 'Adott dátumig') {
      if (!c.end) return null;
      var end = c.end * 1000;
      if (now < end) return end;
      if (!c.restart) return null;
      var period = c.start ? end - c.start * 1000 : 86400000;
      if (period <= 0) period = 86400000;
      return end + (Math.floor((now - end) / period) + 1) * period;
    }

    /* Napi ismétlődő */
    if (c.end && now >= c.end * 1000) return null;
    var s0 = hm(c.dStart), e0 = hm(c.dEnd), carry = e0 <= s0 ? 1 : 0;
    var days = (c.days || []).map(function (d) { return DAYS[d]; });
    var p = parts(now);
    for (var k = 0; k >= -1; k--) {
      var day = new Date(Date.UTC(p.year, p.month - 1, p.day + k));
      if (days.length && days.indexOf(day.getUTCDay()) < 0) continue;
      var s = bp(day.getUTCFullYear(), day.getUTCMonth() + 1, day.getUTCDate(), Math.floor(s0 / 60), s0 % 60);
      var eday = new Date(Date.UTC(p.year, p.month - 1, p.day + k + carry));
      var e2 = bp(eday.getUTCFullYear(), eday.getUTCMonth() + 1, eday.getUTCDate(), Math.floor(e0 / 60), e0 % 60);
      if (now >= s && now < e2) return e2;
    }
    return null;
  }

  /* --- Ország (csak ha a visszaszámlálónál meg van adva) ---------------- */
  var countryP = null;
  function country() {
    if (countryP) return countryP;
    var cached = get(SS, 'mvcd_country');
    if (cached) return (countryP = Promise.resolve(cached));
    countryP = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || ''; set(SS, 'mvcd_country', c); return c; })
      .catch(function () { return ''; });
    return countryP;
  }
  function countryOk(c) {
    if (!c.countries || !c.countries.length) return Promise.resolve(true);
    return country().then(function (cc) {
      if (!cc) return true;
      return c.countries.some(function (x) { return String(x).trim().toUpperCase() === cc.toUpperCase(); });
    });
  }

  function excluded(c) {
    var url = decodeURIComponent(location.pathname + location.search).toLowerCase();
    return (c.exclude || []).some(function (k) { k = String(k).trim().toLowerCase(); return k && url.indexOf(k) > -1; });
  }
  function closed(c) { return get(SS, 'mvcd_closed_' + c.h) === '1'; }

  /* --- Megjelenítés ------------------------------------------------------ */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function build(c, inline) {
    var el = document.createElement(c.cta === 'Az egész sáv kattintható' && c.ctaLink ? 'a' : 'div');
    if (el.tagName === 'A') el.href = c.ctaLink;
    el.className = 'mvcd' + (inline ? ' mvcd--inline' : ' mvcd--bar') + (c.box ? ' mvcd--boxed' : '') + (c.close && !inline ? ' mvcd--closable' : '');
    var bg = c.bgType === 'Színátmenet' ? 'linear-gradient(135deg,' + c.bg + ',' + c.bg2 + ')'
      : c.bgType === 'Kép' && c.img ? 'linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)),url("' + c.img + '") center/cover' : c.bg;
    el.style.cssText = '--mvcd-bg:' + bg + ';--mvcd-fg:' + c.fg + ';--mvcd-num:' + (c.num || c.fg) + ';--mvcd-box:' + (c.box || 'transparent') +
      ';--mvcd-cta-bg:' + c.ctaBg + ';--mvcd-cta-fg:' + c.ctaFg + ';--mvcd-border:' + (c.border || 0) + 'px solid ' + c.borderColor +
      ';--mvcd-title:' + c.titleSize + 'px;--mvcd-numsize:' + c.numSize + 'px';
    var labels = /^\s*ki\s*$/i.test(c.labels || '') ? null : String(c.labels || '').split(',').map(function (s) { return s.trim(); });
    var units = ['d', 'h', 'm', 's'].map(function (u, i) {
      return '<span class="mvcd__u mvcd__u--' + u + '"><span class="mvcd__n" data-u="' + u + '">00</span>' +
        (labels ? '<span class="mvcd__l">' + esc(labels[i] || '') + '</span>' : '') + '</span>';
    });
    var html = '<div class="mvcd__in">';
    if (c.title || c.sub) {
      html += '<div class="mvcd__txt">' + (c.title ? '<p class="mvcd__title">' + esc(c.title) + '</p>' : '') +
        (c.sub ? '<p class="mvcd__sub">' + esc(c.sub) + '</p>' : '') + '</div>';
    }
    html += '<div class="mvcd__timer" role="timer">' + units[0] + '<span class="mvcd__sep mvcd__sep--d">:</span>' + units[1] +
      '<span class="mvcd__sep">:</span>' + units[2] + '<span class="mvcd__sep">:</span>' + units[3] + '</div>';
    if (c.cta === 'Gomb' && c.ctaLink) html += '<a class="mvcd__cta" href="' + esc(c.ctaLink) + '">' + esc(c.ctaText) + '</a>';
    html += '</div>';
    if (c.close && !inline) html += '<button type="button" class="mvcd__x" aria-label="Bezárás">&times;</button>';
    el.innerHTML = html;
    var x = el.querySelector('.mvcd__x');
    if (x) x.addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      set(SS, 'mvcd_closed_' + c.h, '1');
      unmount(el);
    });
    return el;
  }

  var live = [];
  function render(item, now) {
    var left = Math.max(0, Math.floor((item.end - now) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    var n = item.n;
    n.d.textContent = pad(d); n.h.textContent = pad(h); n.m.textContent = pad(m); n.s.textContent = pad(s);
    item.el.classList.toggle('mvcd--days', d > 0);
  }
  function mountItem(c, el, end) {
    var q = function (u) { return el.querySelector('[data-u="' + u + '"]'); };
    var item = { c: c, el: el, end: end, n: { d: q('d'), h: q('h'), m: q('m'), s: q('s') } };
    render(item, Date.now());
    live.push(item);
    return item;
  }

  var bottomPad = 0;
  function unmount(el) {
    live = live.filter(function (it) { return it.el !== el; });
    if (el.classList.contains('mvcd--bottom') && bottomPad) { document.body.style.paddingBottom = ''; bottomPad = 0; }
    var sec = el.closest('.mvcd-section'); if (sec) sec.classList.remove('mvcd-section--sticky');
    el.remove();
  }

  function tick() {
    var now = Date.now();
    live.slice().forEach(function (it) {
      if (now >= it.end) {
        var e = endsAt(it.c, now);
        if (e) it.end = e; else { unmount(it.el); return; }
      }
      render(it, now);
    });
  }

  /* --- Fő sáv (fejléc fölött / oldal alján) ------------------------------ */
  function mountBar() {
    var slot = document.getElementById('mvcd-top'), data = document.getElementById('mvcd-data');
    if (!slot || !data || slot.dataset.done) return;
    slot.dataset.done = '1';
    if (document.getElementById('mvlp-ann')) return; /* a landing saját sávja van kint */
    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return; }
    var now = Date.now();
    var cands = list.filter(function (c) { return !excluded(c) && !closed(c) && endsAt(c, now); })
      .sort(function (a, b) { return (b.p || 0) - (a.p || 0); });
    (function next(i) {
      var c = cands[i]; if (!c) return;
      countryOk(c).then(function (ok) {
        if (!ok) return next(i + 1);
        var end = endsAt(c, Date.now()); if (!end) return next(i + 1);
        var el = build(c, false);
        if (c.bottom) {
          el.classList.add('mvcd--bottom');
          document.body.appendChild(el);
          if (c.sticky) {
            el.classList.add('mvcd--fixed');
            bottomPad = el.offsetHeight;
            document.body.style.paddingBottom = bottomPad + 'px';
          }
        } else {
          slot.appendChild(el);
          if (c.sticky) { var sec = slot.closest('.mvcd-section'); if (sec) sec.classList.add('mvcd-section--sticky'); }
        }
        mountItem(c, el, end);
      });
    })(0);
  }

  /* --- Saját helyen (blokk) ---------------------------------------------- */
  function mountInline() {
    document.querySelectorAll('[data-mvcd-inline]:not([data-done])').forEach(function (slot) {
      slot.setAttribute('data-done', '1');
      var c; try { c = JSON.parse(slot.querySelector('script').textContent); } catch (e) { return; }
      countryOk(c).then(function (ok) {
        var end = ok && endsAt(c, Date.now());
        if (!end) return;
        var el = build(c, true);
        slot.appendChild(el); slot.hidden = false;
        mountItem(c, el, end);
      });
    });
  }

  function scan() { mountBar(); mountInline(); }
  window.__mvcd = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  setInterval(tick, 1000);
})();
